import React from "react";
import { FaRedoAlt, FaSearch } from "react-icons/fa";
import DashboardCard from "./DashboardCard";
import DatePicker from "../../../components/DatePicker";

const dateTabs = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 Days", value: "last7" },
  { label: "Last 30 Days", value: "last30" },
  { label: "Custom", value: "custom" },
];

const FilterBar = ({
  activeTab,
  dateRange,
  isLoading,
  lastUpdated,
  onTabChange,
  onDateChange,
  onRefresh,
}) => {
  return (
    <DashboardCard className="flex flex-wrap items-center gap-2 p-2.5">
      <div className="flex overflow-hidden rounded-md border border-slate-200 dark:border-customBorder">
        {dateTabs.map((tab) => (
          <button
            type="button"
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            className={`h-8 border-r border-slate-200 px-3 text-[11px] font-semibold last:border-r-0 dark:border-customBorder ${
              activeTab === tab.value
                ? "bg-customAccentBlue text-white"
                : "bg-white text-customPrimaryText hover:bg-customSlate dark:bg-customSurface dark:text-customHeading dark:hover:bg-customSurfaceMuted"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="hidden h-7 w-px bg-slate-200 dark:bg-customBorder lg:block" />

      {activeTab === "custom" ? (
        <>
          <label className="flex items-center gap-2 text-[11px] font-medium text-customSecondaryText dark:text-customMuted">
            Start
            {/* <input
              type="date"
              value={dateRange.startDate}
              onChange={(event) => onDateChange("startDate", event.target.value)}
              className="h-8 rounded-md border border-slate-200 bg-white px-2 text-[11px] text-customPrimaryText outline-none focus:border-customAccentBlue dark:border-customBorder dark:bg-customSurface dark:text-customHeading"
            /> */}
            <DatePicker date={dateRange.startDate} onChange={(event) => onDateChange("startDate", event.target.value)} />
          </label>

          <label className="flex items-center gap-2 text-[11px] font-medium text-customSecondaryText dark:text-customMuted">
            End
                {/* <input
                  type="date"
                  value={dateRange.endDate}
                  onChange={(event) => onDateChange("endDate", event.target.value)}
                  className="h-8 rounded-md border border-slate-200 bg-white px-2 text-[11px] text-customPrimaryText outline-none focus:border-customAccentBlue dark:border-customBorder dark:bg-customSurface dark:text-customHeading"
                /> */}
            <DatePicker date={dateRange.endDate} onChange={(event) => onDateChange("endDate", event.target.value)} />
          </label>

          <button
            type="button"
            onClick={onRefresh}
            disabled={isLoading}
            className="flex h-8 items-center gap-2 rounded-md bg-customAccentBlue px-3 text-[11px] font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaSearch className="h-3 w-3" />
            Search
          </button>
        </>
      ) : null}

      {/* <button
        type="button"
        onClick={onRefresh}
        disabled={isLoading}
        className="grid h-8 w-10 place-items-center rounded-md border border-slate-200 bg-white text-customPrimaryText dark:border-customBorder dark:bg-customSurface dark:text-customHeading"
        aria-label="Refresh dashboard"
      >
        <FaRedoAlt className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
      </button> */}

      <p className="ml-auto text-[11px] text-customSecondaryText dark:text-customMuted">
        Last updated:{" "}
        <span className="font-medium text-customPrimaryText dark:text-customHeading">
          {lastUpdated || "-"}
        </span>
      </p>
    </DashboardCard>
  );
};

export default FilterBar;
